<template>
  <li class="episode-item-container">
    <a
      href="javascript:void(0)"
      class="episode-item-layout"
      :title="`${linkTitle}_로 이동`"
      @click.prevent="changeContent(thumb)"
    >
      <div class="episode-image">
        <div class="thumb-image">
          <ul class="badge-list">
            <li class="left-top-area">
              <ul v-top-tag-list="tagList(thumb)"></ul>
            </li>
            <li
              v-common-tag-list="{
                badgeList: thumb.brand_taglist,
                type: 'brand',
              }"
              class="right-top-area"
            />
          </ul>
          <div class="picture-area">
            <WebpImage
              :image-info="{
                imageUrl: thumb.thumbnail,
                width: thumbnailInfo.width,
                height: thumbnailInfo.height,
                alt: linkTitle,
                className: 'thumb',
              }"
            />
          </div>
          <div v-if="thumb.progress && hasLogin" class="vod-progress">
            <span
              class="gradation-purple"
              :style="'width:' + Number(thumb.progress) * 100 + '%;'"
            />
          </div>
        </div>
        <div :class="vodPlayNowClass(thumb)"></div>
      </div>
      <div class="episode-info-container">
        <div v-title-list="{ titleList: thumb.title_list }" class="title-box" />
        <div class="episode-description">
          <p
            v-if="thumb.synopsis"
            ref="synopsis"
            class="episode-synopsis"
            :class="{ 'week6-synopsis': hasHoldBackContentFrom(thumb) }"
            v-html="synopsis"
          />
          <span v-if="thumb.actors" class="episode-actor">
            출연 : {{ thumb.actors }}</span
          >
          <!--          <span v-if="hasHoldBackContentFrom(thumb)" class="week6-text"-->
          <!--            >Wavve Lite 시청 가능</span-->
          <!--          >-->
        </div>
      </div>
    </a>
  </li>
</template>

<script>
  import _ from 'lodash'
  import { addPostfixAndUrl } from '@/common/utils/common'
  import cookie from '@/common/utils/cookie'
  import { getVodProgramsContentid } from '@/common/utils/request'
  import {
    titleList,
    topTagList,
    commonTagList,
  } from '@/common/resources/directives'
  import WebpImage from '@/components/image/WebpImage'

  export default {
    directives: {
      titleList,
      topTagList,
      commonTagList,
    },
    filters: {
      addPostfixAndUrl,
    },
    components: {
      WebpImage,
    },
    props: {
      thumb: {
        type: Object,
      },
      contenttype: {
        type: String,
      },
      isPooqzone: {
        type: Boolean,
      },
      externalContentId: {
        type: String,
        default: '',
      },
      changeContent: {
        type: Function,
      },
      thumbnailInfo: {
        type: Object,
      },
    },
    data() {
      return {
        contentId: '',
        contentInfo: null,
      }
    },
    computed: {
      linkTitle() {
        const titleList = _.get(this.thumb, 'title_list', [])
        const episodeNumberAndDateArray = _.get(titleList, '1.text', 1).split(
          '$O$',
        )
        const episodeNumber =
          episodeNumberAndDateArray[0].indexOf('회') > -1
            ? episodeNumberAndDateArray[0]
            : episodeNumberAndDateArray[0] + '회'
        const episodeTitle = _.get(titleList, '0.text', '')
        return `${episodeNumber} ${episodeTitle}`
      },
      hasLogin() {
        return cookie.getCredential() !== 'none'
      },
      synopsis() {
        const browserName = window.uaInfo.getBrowser().name
        const synopsis = _.get(this.thumb, 'synopsis', '')
        if (
          browserName.toUpperCase() === 'IE' &&
          window.uaInfo.getBrowser().major === '10'
        ) {
          const splitSynopsis = synopsis.split('<br>')
          const firstSynopsis = splitSynopsis[0]
          return firstSynopsis.length < 45
            ? firstSynopsis + '...'
            : firstSynopsis.substr(0, 45) + '...'
        } else {
          return synopsis
        }
      },
      referer() {
        return this.$route?.fullPath ?? '/'
      },
    },
    created() {
      this.contentId = this.externalContentId
      let programId = _.get(this.$route, ['query', 'programid'], '')
      if (this.contentId === '') {
        getVodProgramsContentid({ programid: programId }).then(({ data }) => {
          this.contentId = data.contentid
        })
      }
    },
    methods: {
      url(url) {
        return location.protocol + '//' + url
      },
      addPostfixAndUrl: addPostfixAndUrl,
      vodPlayNowClass(thumb) {
        return this.contentId === thumb.contentid ? 'vod-play-now' : ''
      },
      tagList(thumb) {
        return _.get(thumb, 'top_taglist', []).concat(
          _.get(thumb, 'bottom_taglist', []),
        )
      },
      hasHoldBackContentFrom(thumb) {
        const { holdbackcontent: holdBackContent = '' } = thumb
        return holdBackContent.toLowerCase() === 'y'
      },
    },
  }
</script>
<style lang="scss">
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .player-component01 .week6-synopsis {
    display: block;
    height: 22px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
  }
  .player-component01 .week6-text {
    font-size: 14px;
    line-height: 20px;
    color: #fff;
  }
  .vod-play-now::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: transparent;
    background-image: url(../../../../assets/images/common/ic-now-play.svg);
    background-size: 60px auto;
    background-position: 50% 50%;
    background-repeat: no-repeat;
  }

  .episode-info-container {
    color: $neutral-80;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10px 0 20px;
    .title-box .cell-title:first-of-type .title1 {
      color: #fff;
    }
    .cell-title .title2 {
      font-size: 14px;
      line-height: 20px;
    }
  }
</style>
<style lang="scss" scoped>
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .episode-item-container {
    position: relative;
    display: flex;
    height: auto;
    width: 50%;
    border: 0;
    border-top: 1px solid $neutral-40;
    border-bottom: 1px solid #2f2f2f;
    padding: 20px 0;
    &:nth-child(odd) {
      padding-right: 20px;
    }
    &:nth-child(even) {
      padding-left: 20px;
    }
    &:first-of-type,
    &:nth-of-type(2) {
      border-top: 0;
    }
  }
  .episode-item-layout {
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .episode-image {
    flex-shrink: 0;
    vertical-align: middle;
    overflow: hidden;
    position: relative;
    width: 240px;
    height: 135px;
    border-radius: 12px;
    background-color: $neutral-30;
    .thumb {
      min-height: 100%;
    }
    .vod-progress {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: rgba(0, 0, 0, 0.2);
    }
    .vod-progress span {
      display: block;
      width: 100%;
      height: 4px;
    }
    a:not(.file-down) {
      display: block;
    }
    .tag-top {
      position: absolute;
      left: 8px;
      top: 8px;
      z-index: 10;
    }
  }
  .episode-description {
    overflow: hidden;
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
  }
  .episode-actor {
    @include Ellipsis();
    display: block;
    font-size: 14px;
    line-height: 20px;
    margin-top: 4px;
  }
  .episode-synopsis {
    @include Ellipsis($multi: true, $line: 2);
    br {
      display: none;
    }
  }
</style>
